import React,{useState} from "react";
import AboutPageBanner from "../Components/Banners/AboutPageBanner";
import AboutPageLeadsSection from "../Components/AboutPageComponents/AboutPageLeadsSection";
import Footer from "../Components/Footer";
import AboutPageCoreTeamSection from "../Components/AboutPageComponents/AboutPageCoreTeamSection";
import AboutPageBar from "../Components/Navbar/AboutPageBar";
import ComingSoon from "../Components/ComingSoon";
import AboutPagePartners from "../Components/AboutPageComponents/AboutPagePartners";

export default function AboutPage({ darkToggle, setDarkToggle }) {
  const [comingSoon, setComingSoon] = useState(false);

  const showPopup = () => {
    setComingSoon(!comingSoon);
  };

  return (
    <div className="flex flex-col items-center">
      <AboutPageBar
        darkToggle={darkToggle}
        setDarkToggle={setDarkToggle}
        showPopup={showPopup}
        comingSoon={comingSoon}
      />
      {comingSoon && <ComingSoon showPopup={showPopup} />}

      <marquee className="bg-sky-500 p-4 text-white" direction="right">
        Don't forget to sign up and follow us on social platforms.To stay informed about upcoming events.
      </marquee>

      <AboutPageBanner />
      
      <AboutPageLeadsSection />

      <AboutPageCoreTeamSection />

      <AboutPagePartners/>

      <Footer />
    </div>
  );
}
